// ══════════════════════════════════════════════════════════════════════════════
//  ConfirmModal y PDFConfirmModal.
// ══════════════════════════════════════════════════════════════════════════════
import { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { C, R, E, GLASS } from '../../design.js';
import { Icon } from './Icon.js';
import { Btn } from './botones.js';
import { useEscToClose, useEnterToAccept, useModalZ } from './hooks.js';

// ══════════════════════════════════════════════
//  CONFIRM MODAL — Eliminación y acciones críticas
// ══════════════════════════════════════════════
const ConfirmModal = ({ title, message, confirmLabel="Confirmar", confirmVariant="danger", onConfirm, onClose, children, zIndex }) => {
  const [closing, setClosing] = useState(false);
  const close = useCallback(() => setClosing(true), []);
  useEscToClose(close);
  // Registro inerte A PROPÓSITO: las confirmaciones críticas (eliminar,
  // limpiar) no deben dispararse con un Enter suelto — solo bloquea que
  // el Enter le llegue a un modal de abajo.
  useEnterToAccept(null);
  const z = useModalZ(zIndex);
  const done = e => { if (closing && e.animationName === "gbModalOut") onClose(); };
  useEffect(() => { if (!closing) return; const t = setTimeout(onClose, 240); return () => clearTimeout(t); }, [closing, onClose]);
  return createPortal(
    <div className={["gb-modal-scrim",closing&&"is-closing"].filter(Boolean).join(" ")} style={{position:"fixed",inset:0,...GLASS.scrim,zIndex:z,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div onAnimationEnd={done} className={["gb-modal-panel",closing&&"is-closing"].filter(Boolean).join(" ")} style={{background:C.flotante,borderRadius:R.modal,padding:"28px 32px",maxWidth:420,width:"100%",boxShadow:E.e3,border:`1px solid ${C.border}`}}>
        <div style={{display:"flex",alignItems:"flex-start",gap:14,marginBottom:16}}>
          <div style={{width:38,height:38,borderRadius:R.lg,background:confirmVariant==="danger"?C.criticalLight:C.warningLight,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
            {confirmVariant==="danger"
              ? <Icon name="trash-2" size={18} color={C.critical}/>
              : <Icon name="alert-triangle" size={18} color={C.warning}/>}
          </div>
          <div>
            <div style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:4}}>{title}</div>
            <div style={{fontSize:13,color:C.textSub,lineHeight:1.5}}>{message}</div>
          </div>
        </div>
        {children && <div style={{marginBottom:16}}>{children}</div>}
        <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:20}}>
          <Btn variant="secondary" onClick={close}>Cancelar</Btn>
          <Btn variant={confirmVariant==="danger"?"critical":"primary"} onClick={()=>{onConfirm();close();}}>
            {confirmLabel}
          </Btn>
        </div>
      </div>
    </div>,
    document.body
  );
};

// ── PDFConfirmModal ──
const PDFConfirmModal = ({ title, detail, onConfirm, onClose, children, zIndex }) => {
  const [closing, setClosing] = useState(false);
  const close = useCallback(() => setClosing(true), []);
  useEscToClose(close);
  // Enter = Descargar PDF (acción no destructiva y única del modal).
  useEnterToAccept(closing ? null : () => { onConfirm(); close(); });
  const z = useModalZ(zIndex);
  const done = e => { if (closing && e.animationName === "gbModalOut") onClose(); };
  useEffect(() => { if (!closing) return; const t = setTimeout(onClose, 240); return () => clearTimeout(t); }, [closing, onClose]);
  return createPortal(
    <div className={["gb-modal-scrim",closing&&"is-closing"].filter(Boolean).join(" ")} style={{position:"fixed",inset:0,...GLASS.scrim,zIndex:z,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div onAnimationEnd={done} className={["gb-modal-panel",closing&&"is-closing"].filter(Boolean).join(" ")} style={{background:C.flotante,borderRadius:R.modal,padding:"28px 32px",maxWidth:420,width:"100%",boxShadow:E.e3,border:`1px solid ${C.border}`}}>
        <div style={{display:"flex",alignItems:"flex-start",gap:14,marginBottom:children?12:16}}>
          <div style={{width:38,height:38,borderRadius:R.lg,background:C.primaryLight,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
            <Icon name="file-text" size={18} color={C.primary}/>
          </div>
          <div>
            <div style={{fontSize:15,fontWeight:700,color:C.text,marginBottom:4}}>{title}</div>
            <div style={{fontSize:13,color:C.textSub,lineHeight:1.5}}>{detail}</div>
          </div>
        </div>
        {children}
        <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:20}}>
          <Btn variant="secondary" onClick={close}>Cancelar</Btn>
          <Btn onClick={()=>{onConfirm();close();}} icon="download">Descargar PDF</Btn>
        </div>
      </div>
    </div>,
    document.body
  );
};



export { ConfirmModal, PDFConfirmModal };
